import { useCallback, useEffect, useState } from 'react';

import { ErroRespostaHttp } from '../../../shared/api/http';
import { definirInstrucaoScanPixel, lerInstrucaoScanPixel } from '../api/conteudo';

const ROTULO = 'Abrir a instrução ao entrar em cada enigma';

function mensagemDoErro(erro: unknown): string {
    if (erro instanceof ErroRespostaHttp) {
        if (typeof erro.corpo?.mensagem === 'string') return erro.corpo.mensagem;
        if (erro.status === 401 || erro.status === 403) return 'Sessão expirada ou sem permissão. Entre de novo.';
    }
    return 'Não foi possível salvar. Tente novamente.';
}

/**
 * Scan Pixel (AP8): liga e desliga a instrução que abre sozinha quando o jogador entra em cada
 * enigma. Desligada (o padrão), o jogador vê só o aviso de concluir; o "i" ao lado do título do
 * enigma continua abrindo a instrução quando ele toca. Vale a partir do próximo enigma aberto.
 */
export function InstrucaoScanPixelPainel({ csrfToken }: { csrfToken: string }) {
    const [ligada, setLigada] = useState<boolean | null>(null);
    const [erro, setErro] = useState<string | null>(null);
    const [ocupado, setOcupado] = useState(false);

    const carregar = useCallback(async () => {
        try {
            setLigada((await lerInstrucaoScanPixel()).instrucao_automatica === true);
        } catch (falha) {
            setErro(mensagemDoErro(falha));
        }
    }, []);

    useEffect(() => {
        void carregar();
    }, [carregar]);

    async function alternar() {
        if (ligada === null) return;
        setErro(null);
        setOcupado(true);
        try {
            setLigada((await definirInstrucaoScanPixel(!ligada, csrfToken)).instrucao_automatica === true);
        } catch (falha) {
            // O estado só muda depois da resposta: na falha o switch segue como estava.
            setErro(mensagemDoErro(falha));
        } finally {
            setOcupado(false);
        }
    }

    return (
        <section className="grupo-variaveis" aria-label="Instrução do enigma">
            <h3>Instrução do enigma</h3>
            {erro && <p className="mensagem-login" role="alert">{erro}</p>}
            {ligada !== null && (
                <label className="linha-ranking">
                    <span>{ROTULO}</span>
                    <input
                        type="checkbox" role="switch" checked={ligada} disabled={ocupado}
                        aria-label={ROTULO}
                        onChange={() => void alternar()}
                    />
                </label>
            )}
            <p className="nota-pontuacao">
                Desligada, o jogador vê só o aviso de enigma concluído; o "i" ao lado do título continua
                abrindo a instrução. Vale para todas as turmas, a partir do próximo enigma aberto.
            </p>
        </section>
    );
}
